'use client';
import { subscribeWithEmail } from '@/clients/customer/newsletter-subscribe';
import { validateEmail } from '@/lib/helpers/functions';
import Image from 'next/image';
import React from 'react';
import toast from 'react-hot-toast';
import TermsAndCondition from '../shared/TermsAndCondition';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useTranslations } from 'next-intl';

const GetUpdateHome = ({
  params,
  dictionary,
  lang = 'de',
  data,
}: {
  params: { locale: string };
  dictionary: any;
  lang: string;
  data: any;
}) => {
  const t = useTranslations();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [email, setEmail] = React.useState<string>('');
  const [isProcessing, setIsProcessing] = React.useState<boolean>(false);
  const sectionData = data?.value;

  const handleSubscribe = async () => {
    if (!email) {
      toast.error('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return;
    }
    if (!validateEmail(email)) {
      toast.error('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return;
    }

    const payload: any = {
      email,
      is_customer_type: true,
    };

    const token = await executeRecaptcha?.('newsletter');
    payload['g-recaptcha-response'] = token;

    toast.loading('Bitte warten...');

    setIsProcessing(true);

    subscribeWithEmail(payload, { ['Accept-Language']: params.locale })
      .then((res) => {
        toast.success(res.data.message);
        setEmail('');
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      })
      .finally(() => {
        setIsProcessing(false);
      });
  };

  return (
    <div id="update" className="bg-primary-50">
      <div className="container flex flex-col items-center justify-between gap-x-[30px] py-[100px] md:py-[100px] lg:flex-row">
        <div className="relative h-[300px] w-[300px] shrink-0 md:h-[450px] md:w-[450px]">
          <Image
            src={
              sectionData?.left_image?.image_path ?? '/mail-subscribe-img.png'
            }
            alt={
              sectionData?.left_image?.label?.[lang] ||
              sectionData?.h2?.[lang] ||
              'App Platter price menu'
            }
            // width={1242}
            // height={600}
            fill
            sizes="100vw"
            className="object-contain"
          />
        </div>
        <div className="max-w-[700px] text-center">
          <h2 className="mb-[21px] text-[30px]/[1.3] font-[800] md:text-h1">
            {sectionData?.h2?.[lang] ??
              dictionary.storefront.home.subscribe.header}
            {/* Erhalte regelmäßig Updates */}
          </h2>
          <p className="text-h6 text-paragraph">
            {sectionData?.desc?.[lang] ??
              dictionary.storefront.home.subscribe.subheader}
            {/* Gib deine E-Mail-Adresse ein und verpasse nie wieder Rabattaktionen
            & Events. */}
          </p>
          <div className="mx-auto mt-[41px] max-w-[570px] md:mt-[47px] md:flex md:items-center md:justify-center">
            <div className="relative mx-auto w-[300px] md:w-[350px] lg:w-[300px] xl:w-[380px]">
              <input
                aria-label={t('aria.email_for_subscription')}
                type="email"
                placeholder={
                  sectionData?.input_placeholder?.[lang] ??
                  'maxmustermann@email.com'
                }
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-[110px] border-none bg-white px-[30px] py-[12px] text-h6 text-paragraph shadow-[0px_14px_70px_rgba(0,0,0,0.1)] focus:border-none focus:outline-none focus:ring-0 lg:min-w-[300px]"
              />
              <div className="mt-3 md:absolute">
                <TermsAndCondition
                  className="text-left"
                  btnText={dictionary.subscribe_now}
                  lang={params.locale === 'de-DE' ? 'de' : 'en'}
                />
              </div>
            </div>
            <button
              onClick={handleSubscribe}
              type="submit"
              className="mt-[20px] rounded-[35px] border-2 border-transparent bg-primary-700 px-[20px] py-[11.5px] text-base text-white transition-colors duration-300 hover:border-2 hover:border-primary-700 hover:bg-transparent hover:text-primary-700 md:mt-0 lg:ml-[20px]"
              disabled={isProcessing}
            >
              {sectionData?.button_label?.[lang] ??
                dictionary.storefront.home.subscribe.button}
              {/* Abonniere jetzt */}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetUpdateHome;
